export const GET_COURSES = "GET_COURSES";
export const ADD_COURSE = "ADD_COURSE";
export const UPDATE_COURSE = "UPDATE_COURSE";
export const DELETE_COURSE = "DELETE_COURSE";
export const ADD_LESSON = "ADD_LESSON";
export const UPDATE_LESSON = "UPDATE_LESSON";
export const DELETE_LESSON = "DELETE_LESSON";
export const SELECT_COURSE = "SELECT_COURSE";
export const CREATE_QUIZ = "CREATE_QUIZ";
export const ADD_QUIZ_QUESTION = "ADD_QUIZ_QUESTION";
export const UPDATE_QUIZ_QUESTION = "UPDATE_QUIZ_QUESTION";
export const DELETE_QUIZ_QUESTION = "DELETE_QUIZ_QUESTION";
export const TOGGLE_PUBLISH_STATUS = "TOGGLE_PUBLISH_STATUS";

// Organization Course Actions
export const TOGGLE_COURSE_VISIBILITY = "TOGGLE_COURSE_VISIBILITY";
export const UPDATE_COURSE_ACCESS = "UPDATE_COURSE_ACCESS";
